module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"default.label.add":"Ajouter","default.label.delete":"Supprimer","default.label.empty":"Aucune donnée"}}')
  delete Component.options._Ctor
}
